(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chiije-candle-mug"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function syncVideos(slides, index) {
      slides.forEach(function (slide, i) {
        var video = slide.querySelector('video');
        if (!video) return;
        if (i === index) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    function initGallery(root) {
      if (!root || root.dataset.chiijeMugReady === '1') return;
      var track = root.querySelector('.chiije-candle-mug__track');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-chiije-mug-slide]'));
      if (!track || slides.length < 2) {
        if (slides[0]) {
          var firstVideo = slides[0].querySelector('video');
          if (firstVideo) firstVideo.play().catch(function () {});
        }
        return;
      }
      root.dataset.chiijeMugReady = '1';
      var index = 0;
      var timer = null;
      var paused = false;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var interval = Number(root.getAttribute('data-interval') || 5000);
      if (!interval || interval < 1000) interval = 5000;

      function stop() {
        window.clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        if (!autoplay || document.hidden || paused) return;
        timer = window.setInterval(function () {
          show(index + 1);
        }, interval);
      }

      function show(next) {
        index = ((next % slides.length) + slides.length) % slides.length;
        track.style.transform = 'translateX(' + -index * 100 + '%)';
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });
        root.querySelectorAll('[data-chiije-mug-dot]').forEach(function (dot, i) {
          var active = i === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        syncVideos(slides, index);
        start();
      }

      root.querySelectorAll('[data-chiije-mug-dot]').forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(Number(dot.getAttribute('data-chiije-mug-dot') || 0));
        });
      });
      root.addEventListener('mouseenter', function () { paused = true; stop(); });
      root.addEventListener('mouseleave', function () { paused = false; start(); });
      root.addEventListener('focusin', function () { paused = true; stop(); });
      root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget)) {
          paused = false;
          start();
        }
      });
      if (root._chiijeMugVisibility) {
        document.removeEventListener('visibilitychange', root._chiijeMugVisibility);
      }
      root._chiijeMugVisibility = function () {
        if (document.hidden) stop();
        else start();
      };
      document.addEventListener('visibilitychange', root._chiijeMugVisibility);
      show(0);
    }

    function boot() {
      document.querySelectorAll('[data-chiije-mug-gallery]').forEach(initGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-chiije-mug-gallery]');
      if (root) {
        root.dataset.chiijeMugReady = '';
        initGallery(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chiije-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function headerOffsetEl() {
      return document.querySelector('#header-group') || document.querySelector('header-component') || document.querySelector('header');
    }

    function syncFilterOffset(root) {
      const bar = root.querySelector('[data-chiije-filter-bar]');
      if (!bar) return;
      const header = headerOffsetEl();
      const h = header ? Math.round(header.getBoundingClientRect().height) : 0;
      root.style.setProperty('--chiije-header-offset', h + 'px');
    }

    function initCard(card) {
      const priceEl = card.querySelector('[data-chiije-price]');
      const addBtn = card.querySelector('[data-chiije-add]');
      const sizeBtns = card.querySelectorAll('[data-chiije-size]');

      sizeBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          sizeBtns.forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          if (priceEl && btn.dataset.price) {
            priceEl.textContent = btn.dataset.price;
          }
          var imageUrl = btn.dataset.image;
          if (imageUrl) {
            var img = card.querySelector('.chiije-collection__img');
            if (img) {
              img.src = imageUrl;
              if (btn.dataset.srcset) {
                img.setAttribute('srcset', btn.dataset.srcset);
              } else {
                img.removeAttribute('srcset');
              }
            }
          }
          if (addBtn) {
            addBtn.dataset.variantId = btn.dataset.variantId || '';
            const available = btn.dataset.available !== 'false';
            addBtn.disabled = !available;
            if (!available) {
              addBtn.textContent = 'Sold out';
            } else if (!addBtn.classList.contains('is-added')) {
              addBtn.textContent = 'Add';
            }
          }
        });
      });

      if (!addBtn) return;

      addBtn.addEventListener('click', async function () {
        const variantId = Number(addBtn.dataset.variantId);
        if (!variantId || addBtn.disabled) return;

        const original = addBtn.textContent;
        addBtn.disabled = true;

        try {
          if (window.ChiijeCart && typeof window.ChiijeCart.add === 'function') {
            await window.ChiijeCart.add(variantId, 1);
          } else if (window.ChiijeCart && typeof window.ChiijeCart.addItem === 'function') {
            await window.ChiijeCart.addItem({ id: variantId, quantity: 1 });
          } else {
            const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            const res = await fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
            });
            if (!res.ok) throw new Error('Add failed');
          }

          addBtn.classList.add('is-added');
          addBtn.textContent = 'Added';
          setTimeout(function () {
            addBtn.classList.remove('is-added');
            addBtn.textContent = addBtn.dataset.variantId ? 'Add' : original;
            addBtn.disabled = false;
          }, 1600);
        } catch (err) {
          addBtn.disabled = false;
          addBtn.textContent = original;
          console.error('[chiije-collection] add failed', err);
        }
      });
    }

    function initSection(root) {
      syncFilterOffset(root);
      const header = headerOffsetEl();
      if (header && typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(function () {
          syncFilterOffset(root);
        });
        ro.observe(header);
        window.addEventListener('resize', function () {
          syncFilterOffset(root);
        });
      }
      root.querySelectorAll('[data-chiije-card]').forEach(initCard);
    }

    function boot() {
      document.querySelectorAll('[data-chiije-collection]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const root = event.target && event.target.querySelector
        ? event.target.querySelector('[data-chiije-collection]')
        : null;
      if (root) initSection(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chiije-discovery-set"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDiscovery(root) {
      if (!root || root.dataset.chiijeDiscoveryReady === '1') return;
      root.dataset.chiijeDiscoveryReady = '1';

      var max = Number(root.getAttribute('data-max') || 3);
      var options = Array.prototype.slice.call(root.querySelectorAll('[data-chiije-scent]'));
      var countEl = root.querySelector('[data-chiije-discovery-count]');
      var addBtn = root.querySelector('[data-chiije-discovery-add]');
      var variantId = root.getAttribute('data-variant-id');

      function selected() {
        return options.filter(function (btn) {
          return btn.getAttribute('aria-pressed') === 'true';
        });
      }

      function fill(template, vars) {
        var out = template || '';
        Object.keys(vars).forEach(function (key) {
          out = out.replace(new RegExp('__' + key + '__', 'g'), String(vars[key]));
        });
        return out;
      }

      function refresh() {
        var picks = selected();
        var n = picks.length;
        if (countEl) {
          countEl.textContent = fill(root.getAttribute('data-label-count') || '__n__ of __max__ chosen', {
            n: n,
            max: max
          });
        }

        options.forEach(function (btn) {
          if (btn.disabled) return;
          var on = btn.getAttribute('aria-pressed') === 'true';
          btn.classList.toggle('is-blocked', !on && n >= max);
        });

        if (!addBtn) return;
        if (n < max) {
          addBtn.disabled = true;
          addBtn.textContent = fill(root.getAttribute('data-label-choose-more') || 'Choose __count__ more', {
            count: max - n
          });
        } else {
          addBtn.disabled = !variantId;
          addBtn.textContent = variantId
            ? root.getAttribute('data-label-add') || 'Add my three'
            : root.getAttribute('data-label-missing') || 'Select discovery product';
        }
      }

      options.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var on = btn.getAttribute('aria-pressed') === 'true';
          if (on) {
            btn.setAttribute('aria-pressed', 'false');
          } else if (selected().length >= max) {
            return;
          } else {
            btn.setAttribute('aria-pressed', 'true');
          }
          refresh();
        });
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var picks = selected();
          if (picks.length !== max || !variantId || !window.ChiijeCart) return;
          var properties = {};
          picks.forEach(function (btn, index) {
            var n = index + 1;
            var label = btn.getAttribute('data-number') || btn.getAttribute('data-name') || '';
            var name = btn.getAttribute('data-name') || '';
            var handle = btn.getAttribute('data-handle') || '';
            properties['Scent ' + n] = (label + (name ? ' · ' + name : '')).trim();
            if (handle) {
              properties['Scent ' + n + ' handle'] = handle;
            }
          });
          ChiijeCart.add(variantId, 1, properties, addBtn).catch(function () {
            addBtn.textContent = 'Error';
            window.setTimeout(refresh, 1400);
          });
        });
      }

      refresh();
    }

    function boot() {
      document.querySelectorAll('[data-chiije-discovery]').forEach(initDiscovery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-chiije-discovery]');
      if (root) {
        root.dataset.chiijeDiscoveryReady = '';
        initDiscovery(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chiije-hero-film"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      if (!root || root.dataset.ready === '1') return;
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-chiije-hero-slide]'));
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-chiije-hero-tab]'));
      if (slides.length < 2) return;
      root.dataset.ready = '1';

      var index = 0;
      var timer = null;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var interval = Number(root.getAttribute('data-interval') || 7000);
      root.style.setProperty('--chiije-hero-interval', interval + 'ms');

      function goTo(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        tabs.forEach(function (tab, i) {
          var active = i === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        restartAutoplay();
      }

      function restartAutoplay() {
        window.clearInterval(timer);
        root.classList.toggle('is-autoplaying', autoplay);
        if (!autoplay) return;
        // retrigger progress animation
        tabs.forEach(function (tab) {
          var bar = tab.querySelector('.chiije-hero-film__tab-progress');
          if (!bar) return;
          bar.style.animation = 'none';
          void bar.offsetWidth;
          bar.style.animation = '';
        });
        timer = window.setInterval(function () {
          goTo(index + 1);
        }, interval);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          goTo(Number(tab.getAttribute('data-index') || 0));
        });
      });

      restartAutoplay();
    }

    function boot() {
      document.querySelectorAll('[data-chiije-hero]').forEach(initHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector
        ? event.target.querySelector('[data-chiije-hero]')
        : null;
      if (root) {
        root.dataset.ready = '0';
        initHero(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chiije-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGallery(root) {
      var stage = root.querySelector('[data-chiije-stage]');
      var track = root.querySelector('[data-chiije-track]');
      var thumbs = root.querySelectorAll('[data-chiije-thumb]');
      var slides = root.querySelectorAll('[data-chiije-slide]');
      var prevBtn = root.querySelector('[data-chiije-gallery-prev]');
      var nextBtn = root.querySelector('[data-chiije-gallery-next]');
      if (!stage || !track || !slides.length) return;

      var index = 0;
      var gap = 8;
      var pairQuery = window.matchMedia('(min-width: 750px)');

      function visibleCount() {
        return pairQuery.matches && slides.length > 1 ? 2 : 1;
      }

      function metrics() {
        var vis = visibleCount();
        var width = Math.max(1, (stage.clientWidth - gap * (vis - 1)) / vis);
        return {
          vis: vis,
          width: width,
          maxIndex: Math.max(0, slides.length - vis)
        };
      }

      function setActive(fromIndex) {
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === fromIndex);
        });
        thumbs.forEach(function (thumb, i) {
          var on = i === fromIndex;
          thumb.classList.toggle('is-active', on);
          thumb.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      function updateArrows(maxIndex) {
        if (prevBtn) prevBtn.disabled = index <= 0;
        if (nextBtn) nextBtn.disabled = index >= maxIndex;
        if (prevBtn) prevBtn.hidden = maxIndex === 0;
        if (nextBtn) nextBtn.hidden = maxIndex === 0;
      }

      function apply(animate) {
        var m = metrics();
        index = Math.max(0, Math.min(m.maxIndex, index));
        if (!animate) track.style.transition = 'none';
        track.style.transform = 'translate3d(' + -(index * (m.width + gap)) + 'px,0,0)';
        if (!animate) {
          track.offsetHeight;
          track.style.transition = '';
        }
        updateArrows(m.maxIndex);
        setActive(index);
      }

      function layout() {
        var m = metrics();
        track.style.gap = gap + 'px';
        stage.style.height = m.width + 'px';
        stage.style.aspectRatio = 'auto';
        slides.forEach(function (slide) {
          slide.style.flex = '0 0 ' + m.width + 'px';
          slide.style.width = m.width + 'px';
          slide.style.height = m.width + 'px';
        });
        apply(false);
      }

      function goTo(nextIndex, animate) {
        index = nextIndex;
        apply(animate !== false);
      }

      function goToMedia(mediaId) {
        if (!mediaId) return;
        var target = String(mediaId);
        for (var i = 0; i < slides.length; i++) {
          if (String(slides[i].getAttribute('data-media-id')) === target) {
            goTo(i);
            return;
          }
        }
      }

      root._chiijeGoToMedia = goToMedia;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          goTo(Number(thumb.getAttribute('data-index')) || 0);
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(index - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(index + 1);
        });
      }

      var swipe = { x: 0, scrolling: false };
      stage.addEventListener('touchstart', function (event) {
        if (!event.touches.length) return;
        swipe.x = event.touches[0].clientX;
        swipe.scrolling = true;
      }, { passive: true });
      stage.addEventListener('touchend', function (event) {
        if (!swipe.scrolling) return;
        swipe.scrolling = false;
        var x = event.changedTouches[0] ? event.changedTouches[0].clientX : swipe.x;
        var dx = x - swipe.x;
        if (Math.abs(dx) < 40) return;
        goTo(dx < 0 ? index + 1 : index - 1);
      });

      window.addEventListener('resize', layout);
      if (typeof pairQuery.addEventListener === 'function') {
        pairQuery.addEventListener('change', layout);
      } else if (typeof pairQuery.addListener === 'function') {
        pairQuery.addListener(layout);
      }
      layout();
    }

    function renderAtcLabel(btn, available, price) {
      var addLabel = btn.dataset.addLabel || 'Add to bag';
      var soldOut = btn.dataset.soldOutLabel || 'Sold out';
      if (!available) {
        btn.textContent = soldOut;
        return;
      }
      var priceText = price || btn.dataset.price || '';
      btn.innerHTML =
        '<span data-chiije-atc-label>' +
        addLabel +
        '</span><span class="chiije-product__atc-sep" aria-hidden="true">·</span><span data-chiije-price>' +
        priceText +
        '</span>';
    }

    function setVariant(root, btn) {
      var variantId = btn.dataset.variantId;
      var price = btn.dataset.price || '';
      var compare = btn.dataset.compareAt || '';
      var available = btn.dataset.available !== 'false';
      var chips = root.querySelectorAll('[data-chiije-size]');
      chips.forEach(function (chip) {
        var on = chip === btn;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-chiije-price]').forEach(function (el) {
        if (price) el.textContent = price;
      });
      root.querySelectorAll('[data-chiije-compare]').forEach(function (el) {
        if (compare) {
          el.textContent = compare;
          el.removeAttribute('hidden');
        } else {
          el.textContent = '';
          el.setAttribute('hidden', '');
        }
      });
      root.querySelectorAll('[data-chiije-add]').forEach(function (addBtn) {
        addBtn.dataset.variantId = variantId || '';
        addBtn.dataset.price = price || '';
        addBtn.disabled = !available;
        if (!addBtn.classList.contains('is-busy')) {
          renderAtcLabel(addBtn, available, price);
        }
      });
      if (btn.getAttribute('data-media-id') && typeof root._chiijeGoToMedia === 'function') {
        root._chiijeGoToMedia(btn.getAttribute('data-media-id'));
      }
      var sibling = root.querySelector('[data-chiije-sibling]');
      if (sibling && btn.getAttribute('data-scent-url')) {
        sibling.setAttribute('href', btn.getAttribute('data-scent-url'));
        if (btn.getAttribute('data-scent-label')) {
          sibling.textContent = btn.getAttribute('data-scent-label');
        }
      }
      root.querySelectorAll('[data-chiije-scent-copy]').forEach(function (el) {
        if (el.getAttribute('data-variant-id') === variantId) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
      root.querySelectorAll('[data-chiije-notes][data-variant-id]').forEach(function (el) {
        var on = el.getAttribute('data-variant-id') === variantId;
        if (on) {
          el.removeAttribute('hidden');
          el.classList.add('is-inview');
        } else {
          el.setAttribute('hidden', '');
        }
      });
    }

    function bindAdd(root) {
      root.querySelectorAll('[data-chiije-add]').forEach(function (addBtn) {
        if (!addBtn.dataset.addLabel) {
          var labelEl = addBtn.querySelector('[data-chiije-atc-label]');
          addBtn.dataset.addLabel = labelEl ? labelEl.textContent.trim() : 'Add to bag';
        }
        addBtn.addEventListener('click', async function () {
          var variantId = Number(addBtn.dataset.variantId);
          if (!variantId || addBtn.disabled) return;
          var buttons = root.querySelectorAll('[data-chiije-add]');
          var price = addBtn.dataset.price || '';
          buttons.forEach(function (btn) {
            btn.disabled = true;
            btn.classList.add('is-busy');
          });
          try {
            if (window.ChiijeCart && typeof window.ChiijeCart.add === 'function') {
              await window.ChiijeCart.add(variantId, 1, null, addBtn);
              buttons.forEach(function (btn) {
                if (btn !== addBtn) {
                  btn.textContent = 'Added';
                  window.setTimeout(function () {
                    renderAtcLabel(btn, true, btn.dataset.price || price);
                    btn.disabled = false;
                    btn.classList.remove('is-busy');
                  }, 1400);
                } else {
                  window.setTimeout(function () {
                    renderAtcLabel(btn, true, btn.dataset.price || price);
                    btn.classList.remove('is-busy');
                  }, 1400);
                }
              });
            } else {
              throw new Error('ChiijeCart missing');
            }
          } catch (err) {
            buttons.forEach(function (btn) {
              renderAtcLabel(btn, true, btn.dataset.price || price);
              btn.disabled = false;
              btn.classList.remove('is-busy');
            });
            console.error('[chiije-product] add failed', err);
          }
        });
      });
    }

    function bindSticky(root) {
      var sticky = root.querySelector('[data-chiije-sticky-atc]');
      var buybox = root.querySelector('[data-chiije-buybox]');
      if (!sticky || !buybox || typeof IntersectionObserver === 'undefined') return;
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) sticky.setAttribute('hidden', '');
            else sticky.removeAttribute('hidden');
          });
        },
        { rootMargin: '-40px 0px 0px 0px', threshold: 0 }
      );
      io.observe(buybox);
    }

    function bindNotes(root) {
      var blocks = root.querySelectorAll('[data-chiije-notes]');
      if (!blocks.length || typeof IntersectionObserver === 'undefined') {
        blocks.forEach(function (notes) {
          notes.classList.add('is-inview');
        });
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-inview');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.25 }
      );
      blocks.forEach(function (notes) {
        io.observe(notes);
      });
    }

    function init(root) {
      if (!root || root.dataset.chiijePdpReady === '1') return;
      root.dataset.chiijePdpReady = '1';
      initGallery(root);
      root.querySelectorAll('[data-chiije-size]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setVariant(root, btn);
        });
      });
      bindAdd(root);
      bindSticky(root);
      bindNotes(root);
    }

    function boot() {
      document.querySelectorAll('[data-chiije-pdp]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector
        ? event.target.querySelector('[data-chiije-pdp]') || event.target
        : null;
      if (root && root.hasAttribute && root.hasAttribute('data-chiije-pdp')) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chiije-reuse"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReuse(root) {
      if (!root || root.dataset.chiijeReuseReady === '1') return;
      root.dataset.chiijeReuseReady = '1';

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-chiije-reuse-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-chiije-reuse-dot]'));
      var captionEl = root.querySelector('[data-chiije-reuse-caption]');
      var captions = slides.map(function (slide, index) {
        if (index === 0) {
          return (captionEl && captionEl.textContent.trim()) || '';
        }
        return slide.getAttribute('data-caption') || '';
      });
      var interval = Number(root.getAttribute('data-interval') || 6000);
      var index = 0;
      var timer = null;

      function show(next) {
        index = ((next % slides.length) + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });
        dots.forEach(function (dot, i) {
          var on = i === index;
          dot.classList.toggle('is-active', on);
          dot.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        if (captionEl) captionEl.textContent = captions[index] || '';
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (slides.length < 2) return;
        timer = window.setInterval(function () {
          show(index + 1);
        }, interval);
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(Number(dot.getAttribute('data-index') || 0));
          start();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget)) start();
      });

      show(0);
      start();
    }

    function boot() {
      document.querySelectorAll('[data-chiije-reuse]').forEach(initReuse);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-chiije-reuse]');
      if (root) {
        root.dataset.chiijeReuseReady = '';
        initReuse(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chiije-shop-scents"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function selectSize(card, btn) {
      var priceEl = card.querySelector('[data-chiije-price]');
      var addBtn = card.querySelector('[data-chiije-add]');
      card.querySelectorAll('[data-chiije-size]').forEach(function (el) {
        el.classList.toggle('is-active', el === btn);
      });
      if (priceEl && btn.dataset.price) {
        priceEl.textContent = btn.dataset.price;
      }
      var imageUrl = btn.dataset.image;
      if (imageUrl) {
        var img = card.querySelector('.chiije-shop-scents__photo img');
        if (img) {
          img.src = imageUrl;
          if (btn.dataset.srcset) {
            img.setAttribute('srcset', btn.dataset.srcset);
          } else {
            img.removeAttribute('srcset');
          }
        }
      }
      if (addBtn) {
        addBtn.dataset.variantId = btn.dataset.variantId || '';
        var available = btn.dataset.available !== 'false';
        addBtn.disabled = !available;
        if (!available) {
          addBtn.textContent = 'Sold out';
        } else if (!addBtn.classList.contains('is-added')) {
          addBtn.textContent = addBtn.dataset.chiijeOriginalLabel || 'Add';
        }
      }
    }

    function bind(root) {
      if (!root || root.dataset.chiijeScentsReady === '1') return;
      root.dataset.chiijeScentsReady = '1';

      root.addEventListener('click', function (event) {
        var sizeBtn = event.target.closest('[data-chiije-size]');
        if (sizeBtn && root.contains(sizeBtn)) {
          event.preventDefault();
          var sizeCard = sizeBtn.closest('[data-chiije-home-card]');
          if (sizeCard) selectSize(sizeCard, sizeBtn);
          return;
        }

        var addBtn = event.target.closest('[data-chiije-add]');
        if (!addBtn || !root.contains(addBtn) || !window.ChiijeCart) return;
        event.preventDefault();
        var variantId = addBtn.getAttribute('data-variant-id');
        if (!variantId || addBtn.disabled) return;
        ChiijeCart.add(variantId, 1, null, addBtn).catch(function () {
          addBtn.textContent = 'Error';
          window.setTimeout(function () {
            addBtn.textContent = addBtn.dataset.chiijeOriginalLabel || 'Add';
            addBtn.disabled = false;
          }, 1400);
        });
      });
    }

    function boot() {
      document.querySelectorAll('.chiije-shop-scents').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('.chiije-shop-scents');
      if (root) {
        root.dataset.chiijeScentsReady = '';
        bind(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
